import delhi from './../images/delhiwebp.webp';
import agra from './../images/agrawebp.webp';
import amritsar from './../images/amritsarwebp.webp';
import assam from './../images/assamwebp.webp';
import chandigarh from './../images/chandigarhwebp.webp';
import gurugram from './../images/gurugramwebp.webp';
import ladakh from './../images/ladakhwebp.webp';
import patna from './../images/patnawebp.webp';
import shimla from './../images/shimla.jpg';
// import sikkim from './../images/sikkimwebp.webp'

const CityPicture =[
    {
        name: "Delhi",
        img:  delhi
    },
    {
        name: "Agra",
        img: agra
    },
    {
        name: "Amritsar",
        img: amritsar
    },
    {
        name: "Assam",
        img: assam
    },
    {
        name: "Chandigarh",
        img: chandigarh
    },
    {
        name:"Gurugram",
        img: gurugram
    },
    {
        name:"Ladakh",
        img: ladakh
    },
    {
        name: "Patna",
        img: patna
    },
    {
        name: "Shimla",
        img: shimla
    }
]

export default CityPicture;





